module.exports = __webpack_public_path__ + "static/media/basketball.56fcf4c1.jpg";